import AddIcon from '@mui/icons-material/Add';
import { Button, Divider } from '@mui/material';
import Grid2 from '@mui/material/Unstable_Grid2';
import { cloneDeep, concat, get, set } from 'lodash';
import React, { FC } from 'react';
import CreateForm from 'src/components/ui-component/form-component/create-form/CreateForm';
import MUIAccordionComponent from 'src/components/ui-component/mui-accordion/MUIAccordionComponent';
import { useApplication } from 'src/context/ApplicationContext';
import { ANTRAG_ASSO_PARTNER } from 'src/lib/constants/componentsPath';
import {
	ALS_ERLEDIGT_MARKIEREN_LABEL,
	ANTRAGS_FORMULAREN,
	ART_DES_ANTRAGS,
	FORM_FIELDS_TYPES,
	UEBERARBEITUNGS_HINWEIS_TITLE,
} from 'src/lib/constants/constant';
import { FormStrucItem } from 'src/lib/types/types';
import { EmailValidation, ForceTrue, NonRequired, PhoneNumberValidation, PostalCodeValidation, Required } from 'src/lib/validation/ValidationTypes';
import PruefAssistenz from 'src/pages/private/online-antrag/antrag-components/PruefAssistenz';
import { checkIfPruefAssitenzNeedsToValidate } from 'src/pages/private/online-antrag/application-helper-function/AppHelperfunctions';
import { checkIfSpecificAssoPartnerHasComment } from 'src/pages/private/online-antrag/application-helper-function/PruefAssistenzHelperFunktion';
import { mapCustomFormStrucIndex } from 'src/utils/formStruc';
import { addIndexesToPath, addIndexToPath, checkReadOnlyInUeberarbeitung, getFieldNamefromDataPath, T } from 'src/utils/helper';

// import schemas
import AntragSchema from 'src/lib/paths/antrag_FULL_Paths.json';
import { getTextFieldValidationByDatei } from 'src/lib/validation/fieldValidationHelper';
const P = AntragSchema.attributes;

const AssoziiertepartnerAntragGlobal: FC<{ hasComment?: boolean }> = ({ hasComment }) => {
	const { application, setApplicationProperty, saveApplication, readOnly } = useApplication();
	const updatedReadOnly = checkReadOnlyInUeberarbeitung(application, readOnly, hasComment);
	const antragsformular = get(application, P.Allgemein_Antragsformular.path, '');

	const handleAddPartner = () => {
		let appCopy = cloneDeep(application);
		const key = `${P.Assoziierte_Partner.path}.${get(application, P.Assoziierte_Partner.path, []).length}.Assoziierte_Partner_Strasse_Und_Hausnummer`;
		const keyAP = `${P.Assoziierte_Partner.path}.${get(application, P.Assoziierte_Partner.path, []).length}.Assoziierte_Partner_Ansprechpartnerin.0.Vorname`;
		set(appCopy, key, '');
		set(appCopy, keyAP, '');
		saveApplication(false, appCopy);
	};
	const handleDeleteAssoPartner = (index: number) => {
		let appCopy = cloneDeep(application);
		const allAssoPartner = get(appCopy, P.Assoziierte_Partner.path, []);
		set(
			appCopy,
			P.Assoziierte_Partner.path,
			allAssoPartner.filter((_: any, i: number) => i !== index),
		);
		saveApplication(false, appCopy);
	};

	const getSummaryTitle = (application: any, index: number) => {
		const verbundparterName = get(
			application,
			addIndexesToPath(
				P.Assoziierte_Partner.schema.attributes.Rechtsverbindlicher_Name_Der_Organisation.path,
				[`${index}`],
				['Assoziierte_Partner'],
			),
		);
		let summaryTitle = '';
		switch (antragsformular) {
			case ANTRAGS_FORMULAREN.Loewe:
				summaryTitle = `Assoziierter Partner ${index + 1} ${verbundparterName ? ` | ${verbundparterName}` : ''}`;
				break;
			default:
				summaryTitle = `Assoziierter Partner
								${get(application, addIndexesToPath(P.Assoziierte_Partner.schema.attributes.Rechtsverbindlicher_Name_Der_Organisation.path, [`${index}`], ['Assoziierte_Partner']), `${index + 1} `)}`;
		}
		return summaryTitle;
	};

	return ANTRAGS_FORMULAREN.Loewe === antragsformular ?
			<>
				<CreateForm
					formStruc={formStrucLoewe(application, hasComment, readOnly)}
					formValues={application}
					updateFormValuesFunc={setApplicationProperty}
					readOnly={updatedReadOnly}
				/>
			</>
		:	<>
				{(get(application, P.Assoziierte_Partner.path, [{}]) as Array<any>).map((eachPartner, index) => {
					const hasCommentPartner = checkIfSpecificAssoPartnerHasComment(readOnly, eachPartner);
					return (
						<MUIAccordionComponent
							key={index}
							summaryTitle={getSummaryTitle(application, index)}
							onDelete={() => handleDeleteAssoPartner(index)}
							showDeleteButton={!updatedReadOnly}
							hasComment={hasCommentPartner}
						>
							<PruefAssistenz
								statusPath={addIndexesToPath(P.Assoziierte_Partner.schema.attributes.Pruefstatus.path, [`${index}`], ['Assoziierte_Partner'])}
								hinweisPath={addIndexesToPath(
									P.Assoziierte_Partner.schema.attributes.Hinweis_Fuer_Den_Antragsteller.path,
									[`${index}`],
									['Assoziierte_Partner'],
								)}
								ueberarbeitetAmPath={addIndexesToPath(
									P.Assoziierte_Partner.schema.attributes.Ueberarbeitet_Am.path,
									[`${index}`],
									['Assoziierte_Partner'],
								)}
								erledigtPath={addIndexesToPath(
									P.Assoziierte_Partner.schema.attributes.Erledigt_Durch_Antragsteller.path,
									[`${index}`],
									['Assoziierte_Partner'],
								)}
								formStruc={mapVPartner(formStrucPruefAssistenz(), index)}
							/>

							<Grid2 spacing={6} container>
								<Grid2 sm={6}>
									<CreateForm
										formStruc={mapVPartner(formStrucGeneral(application, index), index)}
										formValues={application}
										updateFormValuesFunc={setApplicationProperty}
										readOnly={updatedReadOnly}
									/>
								</Grid2>
								<Grid2 sm={6}>
									<CreateForm
										formStruc={mapVPartner(formStrucGeneral2(application, index), index)}
										formValues={application}
										updateFormValuesFunc={setApplicationProperty}
										readOnly={updatedReadOnly}
									/>
								</Grid2>
							</Grid2>

							<CreateForm
								formStruc={mapVPartner(formStrucAPAP(), index)}
								formValues={application}
								updateFormValuesFunc={setApplicationProperty}
								readOnly={updatedReadOnly}
							/>
						</MUIAccordionComponent>
					);
				})}
				<Divider sx={{ mt: '2rem' }} />
				<Button sx={{ mt: '1rem' }} endIcon={<AddIcon />} onClick={handleAddPartner} disabled={updatedReadOnly}>
					Assoziierte Partner hinzufügen
				</Button>
			</>;
};

export default AssoziiertepartnerAntragGlobal;

// FormStruc Prüfassistenz
const formStrucPruefAssistenz = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...P.Assoziierte_Partner.schema.attributes.Erledigt_Durch_Antragsteller,
					label: ALS_ERLEDIGT_MARKIEREN_LABEL,
					validation: [{ validateFunction: ForceTrue }],
				},
			],
		},
	];
	return struc;
};
const formStrucGeneral = (application: any, index: number) => {
	const partnerNamePath = addIndexesToPath(
		P.Assoziierte_Partner.schema.attributes.Rechtsverbindlicher_Name_Der_Organisation.path,
		[`${index}`],
		['Assoziierte_Partner'],
	);
	const hasPartnerName = Boolean(get(application, partnerNamePath, ''));
	const getValidation = (existingValidation: any[] = []) => {
		if (!hasPartnerName) return [{ validateFunction: NonRequired }];
		return existingValidation.length > 0 ? existingValidation : [{ validateFunction: Required }];
	};

	let struc: FormStrucItem[] = [
		{
			fields: [
				{ ...P.Assoziierte_Partner.schema.attributes.Rechtsverbindlicher_Name_Der_Organisation, validation: [{ validateFunction: NonRequired }] },
				{
					...P.Assoziierte_Partner.schema.attributes.Assoziierte_Partner_Strasse_Und_Hausnummer,
					validation: getValidation(),
				},
			],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
		{
			fields: [
				{
					...P.Assoziierte_Partner.schema.attributes.Assoziierte_Partner_PLZ,
					maxDigit: 5,
					validation: getValidation([{ validateFunction: Required }, { validateFunction: PostalCodeValidation }]),
				},
				{
					...P.Assoziierte_Partner.schema.attributes.Assoziierte_Partner_Ort,
					validation: getValidation(),
				},
			],
		},
		{
			fields: [
				{
					...P.Assoziierte_Partner.schema.attributes.Assoziierte_Partner_Telefonnummer,
					validation: getValidation(),
				},
				{
					...P.Assoziierte_Partner.schema.attributes.Assoziierte_Partner_E_Mail_Adresse,
					validation: getValidation([{ validateFunction: Required }, { validateFunction: EmailValidation }]),
				},
			],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];
	return struc;
};
const formStrucGeneral2 = (application: any, index: number) => {
	const partner = get(application, `${P.Assoziierte_Partner.path}.${index}`, {});
	const isFormantrag = get(application, P.Allgemein_Art_Des_Antrags.path, '') === ART_DES_ANTRAGS.Formantrag;
	const currentName = get(
		partner,
		getFieldNamefromDataPath(P.Assoziierte_Partner.schema.attributes.Rechtsverbindlicher_Name_Der_Organisation.path),
		'',
	);

	const skizzePartners = get(application, P.Skizze.schema.attributes.Assoziierte_Partner.path, []);
	const urspruenglicherPartners = get(application, P.urspruenglicher_Antrag.schema.attributes.Assoziierte_Partner.path, []);
	const referencePartner = isFormantrag ? urspruenglicherPartners[index] : skizzePartners[index];
	const loiVorhandenKey = getFieldNamefromDataPath(P.Assoziierte_Partner.schema.attributes.LOI_Vorhanden.path);
	const referenceHasLoiId = Boolean(get(referencePartner, 'LOI_Datei.id'));
	/**
	 * Only show LOI_Vorhanden checkbox if the reference and current partner have a
	 * LOI_Vorhanden value of true or the reference partner already has a LOI file.
	 */
	const referenceHasLoiVorhanden =
		Boolean(get(referencePartner, loiVorhandenKey, false)) &&
		Boolean(
			get(application, addIndexesToPath(P.Assoziierte_Partner.schema.attributes.LOI_Vorhanden.path, [`${index}`], ['Assoziierte_Partner']), false),
		);
	const referenceName = get(
		referencePartner,
		getFieldNamefromDataPath(P.Assoziierte_Partner.schema.attributes.Rechtsverbindlicher_Name_Der_Organisation.path),
		'',
	);

	const isExistingPartner = (referenceHasLoiId || referenceHasLoiVorhanden) && Boolean(currentName) && currentName === referenceName;

	const hasPartnerName = Boolean(currentName);
	const getValidation = (existingValidation: any[] = []) => {
		if (!hasPartnerName) return [{ validateFunction: NonRequired }];
		return existingValidation.length > 0 ? existingValidation : [{ validateFunction: Required }];
	};

	const loiField =
		isExistingPartner ?
			{
				...P.Assoziierte_Partner.schema.attributes.LOI_Vorhanden,
				type: 'checkbox',
				disabled: true,
				validation: [{ validateFunction: NonRequired }],
			}
		:	{ ...P.Assoziierte_Partner.schema.attributes.LOI_Datei, validation: getValidation() };
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...P.Assoziierte_Partner.schema.attributes.Rechtsform_Der_Organisation,
					validation: getValidation(),
				},
				{
					...P.Assoziierte_Partner.schema.attributes.Institutionstyp,
					validation: getValidation(),
					// options: getInstitutionsTypOption(application),
				},
				{
					...P.Assoziierte_Partner.schema.attributes.Relevante_Kernkompentenz,
					validation: getValidation(),
				},
				loiField,
			],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];
	return struc;
};
const formStrucAPAP = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...P.Assoziierte_Partner.schema.attributes.Assoziierte_Partner_Ansprechpartnerin,
					tableLabel: 'Ansprechpartner/in',
					type: FORM_FIELDS_TYPES.editableTable,
				},
			],
			userProps: { columnToDivide: 1 },
		},
	];
	return struc;
};

const shouldShowExistingLoiCheckbox = (application: any, row: any, index: number) => {
	const isFormantrag = get(application, P.Allgemein_Art_Des_Antrags.path, '') === ART_DES_ANTRAGS.Formantrag;
	const skizzePartners = get(application, P.Skizze.schema.attributes.Assoziierte_Partner.path, []);
	const urspruenglicherPartners = get(application, P.urspruenglicher_Antrag.schema.attributes.Assoziierte_Partner.path, []);
	const referencePartner = isFormantrag ? urspruenglicherPartners[index] : skizzePartners[index];
	const nameKey = getFieldNamefromDataPath(P.Assoziierte_Partner.schema.attributes.Rechtsverbindlicher_Name_Der_Organisation.path);
	const loiVorhandenKey = getFieldNamefromDataPath(P.Assoziierte_Partner.schema.attributes.LOI_Vorhanden.path);
	const currentName = get(row, nameKey, '');
	const referenceName = get(referencePartner, nameKey, '');
	const referenceHasLoi = Boolean(get(referencePartner, 'LOI_Datei.id')) || Boolean(get(referencePartner, loiVorhandenKey, false));
	console.log('shouldShowExistingLoiCheckbox', { referenceHasLoi, currentName, referenceName });
	return referenceHasLoi && Boolean(currentName) && currentName === referenceName;
};

const formStrucLoewe = (application: any, hasComment: boolean | undefined, readOnly: boolean): FormStrucItem[] => {
	const hideCellWithoutComment = (row: any) => !checkIfSpecificAssoPartnerHasComment(readOnly, row);
	const hideColumns = [
		'Partner',
		'Institutionstyp',
		'Rechtsform_Der_Organisation',
		'Relevante_Kernkompentenz',
		'Assoziierte_Partner_Strasse_Und_Hausnummer',
		'Assoziierte_Partner_Telefonnummer',
		'Assoziierte_Partner_E_Mail_Adresse',
		'LOI_Vorhanden',
		'Assoziierte_Partner_Ansprechpartnerin',
		'Pruefstatus',
		'Freigegeben_Am',
		'Ueberarbeitet_Am',
	];

	if (!hasComment) {
		hideColumns.push('Erledigt_Durch_Antragsteller', 'Hinweis_Fuer_Den_Antragsteller');
	}

	return [
		{
			fields: [
				{
					...P.Assoziierte_Partner,
					type: FORM_FIELDS_TYPES.editableTable,
					hideColumns,
					disabledColumns: ['Hinweis_Fuer_Den_Antragsteller'],
					fieldProps: {
						[getFieldNamefromDataPath(P.Assoziierte_Partner.schema.attributes.Rechtsverbindlicher_Name_Der_Organisation.path)]: {
							label: T(getFieldNamefromDataPath(P.Assoziierte_Partner.schema.attributes.Rechtsverbindlicher_Name_Der_Organisation.path)),
							maxWidth: '80px',
						},
						[getFieldNamefromDataPath(P.Assoziierte_Partner.schema.attributes.Assoziierte_Partner_PLZ.path)]: {
							label: T(getFieldNamefromDataPath(P.Assoziierte_Partner.schema.attributes.Assoziierte_Partner_PLZ.path)),
							type: FORM_FIELDS_TYPES.integer,
							width: '100px',
						},
						[getFieldNamefromDataPath(P.Assoziierte_Partner.schema.attributes.Assoziierte_Partner_Ort.path)]: {
							label: T(getFieldNamefromDataPath(P.Assoziierte_Partner.schema.attributes.Assoziierte_Partner_Ort.path)),
							maxWidth: '70px',
						},
						[getFieldNamefromDataPath(P.Assoziierte_Partner.schema.attributes.LOI_Datei.path)]: {
							label: 'LOI des assoziierten Partners',
							maxWidth: '90px',
							tooltip:
								'Bitte laden Sie hier den Letter of Intent (LOI) des assoziierten Partners hoch. Wird stattdessen eine Checkbox angezeigt, liegt der LOI bereits vor und muss nicht erneut hochgeladen werden.',
							getFieldProps: (row: any, index: number) => {
								if (shouldShowExistingLoiCheckbox(application, row, index)) {
									return {
										...P.Assoziierte_Partner.schema.attributes.LOI_Vorhanden,
										fieldKey: getFieldNamefromDataPath(P.Assoziierte_Partner.schema.attributes.LOI_Vorhanden.path),
										type: FORM_FIELDS_TYPES.checkbox,
										disabled: true,
										fieldValue: true,
										validation: [{ validateFunction: NonRequired }],
									};
								}

								return {
									...P.Assoziierte_Partner.schema.attributes.LOI_Datei,
									fieldKey: getFieldNamefromDataPath(P.Assoziierte_Partner.schema.attributes.LOI_Datei.path),
									validation: [
										{
											validateFunction:
												(
													get(
														row,
														getFieldNamefromDataPath(
															P.Assoziierte_Partner.schema.attributes.Rechtsverbindlicher_Name_Der_Organisation.path,
														),
														'',
													)
												) ?
													Required
												:	NonRequired,
										},
									],
								};
							},
						},
						[getFieldNamefromDataPath(P.Assoziierte_Partner.schema.attributes.Erledigt_Durch_Antragsteller.path)]: {
							label: 'Erledigt',
							maxWidth: '40px',
							hideCell: hideCellWithoutComment,
						},
						[getFieldNamefromDataPath(P.Assoziierte_Partner.schema.attributes.Hinweis_Fuer_Den_Antragsteller.path)]: {
							label: UEBERARBEITUNGS_HINWEIS_TITLE,
							maxWidth: '90px',
							hideCell: hideCellWithoutComment,
						},
					},
				},
			],
			userProps: { columnToDivide: 1 },
		},
	];
};

const customFormStrucLoewe = (application: any, i: number) => {
	const loi = get(application, addIndexToPath(P.Assoziierte_Partner.schema.attributes.LOI_Datei.path, i, P.Assoziierte_Partner.path), '');
	let struc: FormStrucItem[] = [
		{
			fields: [
				{ ...P.Assoziierte_Partner.schema.attributes.Assoziierte_Partner_PLZ, validation: [{ validateFunction: loi ? Required : NonRequired }] },
				// { ...P.Assoziierte_Partner.schema.attributes.LOI_Datei, validation: [{ validateFunction: loi ? Required : NonRequired }] },
				{ ...P.Assoziierte_Partner.schema.attributes.Assoziierte_Partner_Ort, validation: [{ validateFunction: loi ? Required : NonRequired }] },
				{
					...P.Assoziierte_Partner.schema.attributes.Rechtsverbindlicher_Name_Der_Organisation,
					validation: getTextFieldValidationByDatei(loi),
				},
			],
		},
	];
	return struc;
};

const customFormStrucAnsprechpartner = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				P.Assoziierte_Partner.schema.attributes.Assoziierte_Partner_Ansprechpartnerin.schema.attributes.Vorname,
				P.Assoziierte_Partner.schema.attributes.Assoziierte_Partner_Ansprechpartnerin.schema.attributes.Nachname,
				{
					...P.Assoziierte_Partner.schema.attributes.Assoziierte_Partner_Ansprechpartnerin.schema.attributes.Telefonnummer,
					validation: [{ validateFunction: Required }, { validateFunction: PhoneNumberValidation }],
				},
				{
					...P.Assoziierte_Partner.schema.attributes.Assoziierte_Partner_Ansprechpartnerin.schema.attributes.E_45_Mail_45_Adresse,
					validation: [{ validateFunction: Required }, { validateFunction: EmailValidation }],
				},
			],
			userProps: { columnToDivide: 2 },
		},
	];
	return struc;
};

const mapVPartner = (formStruc: any[], index: number) => {
	let result = formStruc.map((row) => {
		return {
			...row,
			fields: (get(row, 'fields', []) as Array<any>).map((value) => {
				let pathWithoutIndex = get(value, 'path', '') as string;
				return {
					...value,
					path:
						pathWithoutIndex.slice(0, P.Assoziierte_Partner.path.length) +
						`.${index}` +
						pathWithoutIndex.slice(P.Assoziierte_Partner.path.length),
				};
			}),
		};
	});
	return result;
};
const mapVPartnerAnsprechpartner = (formStruc: any[], index: number, apIndex: number) => {
	let result = formStruc.map((row) => {
		return {
			...row,
			fields: (get(row, 'fields', []) as Array<any>)
				.map((value) => {
					let pathWithoutIndex = get(value, 'path', '') as string;
					return {
						...value,
						path:
							pathWithoutIndex.slice(0, P.Assoziierte_Partner.schema.attributes.Assoziierte_Partner_Ansprechpartnerin.path.length) +
							`.${apIndex}` +
							pathWithoutIndex.slice(P.Assoziierte_Partner.schema.attributes.Assoziierte_Partner_Ansprechpartnerin.path.length),
					};
				})
				.map((value) => {
					let pathWithoutIndex = get(value, 'path', '') as string;
					return {
						...value,
						path:
							pathWithoutIndex.slice(0, P.Assoziierte_Partner.path.length) +
							`.${index}` +
							pathWithoutIndex.slice(P.Assoziierte_Partner.path.length),
					};
				}),
		};
	});
	return result;
};

export function getFormStrucAssoziertepartnerAntragGlobal(application: any): FormStrucItem[] {
	const assoziiertePartner = get(application, P.Assoziierte_Partner.path, [{}]) as Array<any>;
	const antragsformular = get(application, P.Allgemein_Antragsformular.path, '');
	let completeStruc: FormStrucItem[] = [];
	assoziiertePartner.forEach((aPartner: any, index: number) => {
		if (ANTRAGS_FORMULAREN.Loewe === antragsformular) {
			const customFormStrucLoeweWithIndex = mapVPartner(customFormStrucLoewe(application, index), index);
			completeStruc = concat(completeStruc, customFormStrucLoeweWithIndex);
		} else {
			const formStrucAssoziiertePartnerAPLength = get(aPartner, 'Assoziierte_Partner_Ansprechpartnerin', []).length;
			const formStrucVPGeneralWithIndex = mapVPartner(formStrucGeneral(application, index), index);
			const formStrucVPGeneral2WithIndex = mapVPartner(formStrucGeneral2(application, index), index);

			const aPartnerAPwithIndex = mapCustomFormStrucIndex(
				application,
				customFormStrucAnsprechpartner(),
				P.Verbundpartner.schema.attributes.Verbundpartner_Ansprechpartnerin,
			);

			let assoziiertePartnerStruc = concat(formStrucVPGeneralWithIndex, formStrucVPGeneral2WithIndex, aPartnerAPwithIndex);
			for (let apIndex = 0; apIndex < formStrucAssoziiertePartnerAPLength; apIndex++) {
				assoziiertePartnerStruc = concat(assoziiertePartnerStruc, mapVPartnerAnsprechpartner(customFormStrucAnsprechpartner(), index, apIndex));
			}
			completeStruc = concat(completeStruc, assoziiertePartnerStruc);
		}

		// FormStruc mapped for Prüfassistenz
		const formStrucPruefAssistezWithIndex = mapVPartner(formStrucPruefAssistenz(), index);
		const checkPruefAssitenz = checkIfPruefAssitenzNeedsToValidate(
			aPartner,
			ANTRAG_ASSO_PARTNER.UeberarbeitungHinweisStatus,
			ANTRAG_ASSO_PARTNER.UeberarbeitungHinweisErledigt,
		);

		if (checkPruefAssitenz) {
			completeStruc = concat(formStrucPruefAssistezWithIndex, completeStruc);
		}
	});

	return completeStruc;
}
